export default "__VITE_ASSET__kmx_G9VX__"